import { Line } from 'react-chartjs-2';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  colors,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { fetchUsersReport } from 'src/store/actions/reports.action';
import LoadingProgress from '../LoadingProgress';

function UsersReport(props) {
  const dispatch = useDispatch();

  const [userReport, setUserReport] = useState(null);
  const { userReportStatus } = useSelector((state) => state.reports);

  useEffect(() => {
    const fetchReport = async () => {
      try {
        const response = await dispatch(fetchUsersReport()).unwrap();
        if (response) {
          setUserReport(response.data);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchReport();
  }, [dispatch]);

  const data = userReport ? {
    datasets: [
      {
        backgroundColor: colors.blue[500],
        fill: false,
        lineTension: 0.5,
        borderColor: colors.blue[500],
        borderWidth: 2,
        data: userReport.currentYear.map((item) => item.count),
        label: userReport.currentYearTitle,
      },
      {
        backgroundColor: colors.red[500],
        fill: false,
        lineTension: 0.5,
        borderColor: colors.red[500],
        borderWidth: 2,
        data: userReport.previousYear.map((item) => item.count),
        label: userReport.previousYearTitle,
      },
    ],
    labels: userReport.currentYear.map((item) => `${item.monthText}`),
  } : { datasets: [] };

  const options = {
    animation: true,
    cornerRadius: 20,
    layout: { padding: 0 },
    legend: { display: false },
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
      },
    },
  };

  return (
    <Card>
      <CardHeader
        title="Users"
      />
      <Divider />
      <CardContent>
        <Box
          sx={{
            height: 300,
            position: 'relative',
          }}
        >
          {userReportStatus === 'loading' ? <LoadingProgress /> : (
            <Line
              data={data}
              options={options}
            />
          )}

        </Box>
      </CardContent>
    </Card>
  );
}

export default UsersReport;
